import React from 'react';
import {useSelector} from 'react-redux';
import {RootState} from 'modules';
import Screen from 'components/player/Screen';

/**
 * 플레이어 화면 영역 컨테이너
 */

// interface IScreenContainerProps {}

const ScreenContainer = () => {
  const paused = useSelector((state: RootState) => state.video.paused);

  return <Screen isPaused={paused} />;
};

export default ScreenContainer;
